// extracted by mini-css-extract-plugin
export default {"small":"-8C2M","medium":"bGr+K","large":"S8dzr","radialProgress":"UbbuG","spin":"_85o2H"};